import { useQuery } from '@tanstack/react-query';
import { RelatedSignalsApiRequest } from '@momentum/types';
import { signalService } from '../services';

export const useRelatedSignals = (
  query: RelatedSignalsApiRequest,
  enabled = true
) => {
  const { subject } = query;
  const shouldFetch = enabled && Boolean(subject.title && subject.description);

  return useQuery({
    queryKey: [
      'relatedSignals',
      subject.source,
      subject.externalId,
      subject.title,
      subject.description,
    ],
    queryFn: () => signalService.getRelatedSignals(query),
    enabled: shouldFetch,
    retry: false,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
};
